module.exports = __webpack_public_path__ + "img/ab.f3633f0a.png";